import {type PlayerColor, type VictoryPointState} from '../PlayerState.ts'

export interface EndGamePlayerState {
    color: PlayerColor
    rank: number
    victoryPoints: VictoryPointState
    winningPlayer: boolean
    title: PlayerTitleEnum | undefined
}

// Don't change order. Used for analytics
export enum PlayerTitleEnum {
    Monopolist = 0,
    Juggernaut = 1
}
